import apiFetch from '../apiFetch'

export default function (token, dossierId, isHistorical) {
  return apiFetch({ endPoint: `ivaType?dossierId=${dossierId}&isHistorical=${isHistorical}`, method: 'GET', body: null, token: token })
}
